module.exports = __webpack_public_path__ + "img/FR13106.55265b51.png";